// ** Initial State
const initialState = {
  allData: [],
  data: [],
  total: 1,
  params: {}
}

const tenants = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_TENANTS':
      return { ...state, allData: action.data }
    case 'FILTER_ALL_TENANTS':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    default:
      return { ...state }
  }
}
export default tenants
